import type { FC } from "react";

import type {
  TDropdownMenuProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import {
  DropdownMenuContent,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenuContent";
import {
  DropdownMenuRoot,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenuRoot";
import {
  DropdownMenuTrigger,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenuTrigger";
import { Button } from "@/ui/components/primitives/Button";

export const DropdownMenu: FC<TDropdownMenuProps> = (
  {
    children,
    contentClassName,
    label,
    triggerClassName,
    ...props
  },
) => (
  <DropdownMenuRoot {...props}>
    <DropdownMenuTrigger asChild className={triggerClassName}>
      <Button variant="tertiary" icon="chevronDown">
        { label }
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className={contentClassName}>
      { children }
    </DropdownMenuContent>
  </DropdownMenuRoot>
);

DropdownMenu.displayName = "DropdownMenu";
